<rsf-toolbar
  [rsf]="rsf"
  [isViewingAmendment]="!!status.isViewingAmendment"
  [showAmendmentToggle]="showAmendmentToggle"
  [moduleTitle]="moduleTitle"
  (menuClicked)="toggleSidenav()"
  (isViewingAmendmentChanged)="isViewingAmendmentChanged($event)"
></rsf-toolbar>
<mat-sidenav-container
  class="sidenav-container mat-sidenav-collapse-transition"
  autosize
>
  <mat-sidenav
    [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
    #sidenav
    opened="true"
    class="d-print-none"
    mode="side"
    (mouseenter)="mouseenter()"
    (mouseleave)="mouseleave()"
  >
    <mat-nav-list>
      <!-- Filter box -->
      <mat-list-item>
        <mat-icon matListItemIcon *ngIf="!isExpanded && !isShowing" class="blue"
          >search</mat-icon
        >
        <filter-box
          (changed)="applyFilter($event)"
          *ngIf="isExpanded || isShowing"
        ></filter-box>
      </mat-list-item>

      <!-- Table -->
      <mat-list-item style="height: unset">
        <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
          <rsf-side
            [filter]="filter"
            (rowSelected)="rowSelected($event)"
          ></rsf-side>
        </div>
      </mat-list-item>
    </mat-nav-list>

    <rsf-buttons
      #rsfButtons
      [rsf]="rsf"
      [rsfAmendment]="rsfAmendment"
      [privileges]="privileges"
      [status]="status"
      (clicked)="buttonClicked($event)"
    ></rsf-buttons>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="d-flex flex-column justify-content-between">
      <div
        class="sidenav-content"
        [ngClass]="{
          scrollbar: innerWidth > 576,
          amendment: false
        }"
      >
        <rsf-main
          [rsf]="rsf"
          *ngIf="!rsfButtons.showHistory?.value"
          [rsfAmendment]="rsfAmendment"
          [privileges]="privileges"
          [status]="status"
          [disabled]="disabled"
          [service]="service"
          (buttonAction)="buttonClicked($event)"
        ></rsf-main>
        <form-history
          [form]="rsf"
          class="mt-2"
          *ngIf="!!rsfButtons.showHistory?.value && rsf"
        ></form-history>
      </div>
      <div
        class="buttons d-print-none"
        id="sidenav-content-buttons"
        [ngClass]="{}"
      ></div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
